import { render } from "./selectDepartmentModel.vue?vue&type=template&id=06f35fee"
import script from "./selectDepartmentModel.vue?vue&type=script&lang=js"
export * from "./selectDepartmentModel.vue?vue&type=script&lang=js"

import "./selectDepartmentModel.vue?vue&type=style&index=0&id=06f35fee&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__